function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.09 23.34l-3.94-3.64a.188.188 0 00-.024-.017l-.018-.014a.705.705 0 00-.044-.034l-.018-.013-.02-.014a.877.877 0 00-.886-.082l-4.2 2.237h-2.028l-2.295-.316a5.406 5.406 0 00-3.091-.294l-.994 1.287v.702c0 .839.684 1.519 1.531 1.519h17.953c.428-.008.808-.355.89-.79l-2.816-.531zm-5.932-.457l-.091-.095.715-.593.002.001.504-.434.061-.053.509.47a.894.894 0 00.188.137l.657.384-1.227-.232-1.318.415z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.292 20.217c-.465.61-.34 1.475.274 1.934.467.349 1.039.332 1.555.081.317-.152.567-.197.895-.042l.431-.566a.617.617 0 00-.125-.873l-1.079-.806-.048-.037a1.403 1.403 0 00-1.903.309z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.736 24.66h3.212v-.564a.978.978 0 00-.981-.973H4.942l-.215.43h-.08v-1.118c-.012-.296-.106-.46-.288-.64L3.094 20.54v2.494c0 .898.732 1.626 1.642 1.626zM2.588 28a.588.588 0 110-1.176h26.824a.588.588 0 110 1.176H2.588z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.686 6.76a3.626 3.626 0 00-2.22-.76V4c1.246 0 2.456.415 3.443 1.179a5.735 5.735 0 012.024 3.042 5.793 5.793 0 01-.212 3.656 5.714 5.714 0 01-2.363 2.783 5.615 5.615 0 01-6.838-.816 5.754 5.754 0 01-1.657-3.26 5.787 5.787 0 01.633-3.605l1.76.952a3.787 3.787 0 00-.415 2.36c.121.811.502 1.558 1.08 2.126a3.615 3.615 0 004.408.528 3.713 3.713 0 001.535-1.81c.303-.76.352-1.6.138-2.392a3.734 3.734 0 00-1.316-1.982z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.89 6.047a3.653 3.653 0 00-2.25 1.307l-1.552-1.26a5.653 5.653 0 013.48-2.022l.321 1.975z",
  fill: "currentColor"
})));